import { SystemTypeConstants } from '@frontend-site/shared/data';

export const SANDBOX_SYSTEM_NAME = 'Panaya_Sandbox';

export function isSandboxSystem(systemName: string): boolean {
    return systemName === SANDBOX_SYSTEM_NAME;
}

export function isSapOrOracleSystem(systemType: string): boolean {
    return systemType === SystemTypeConstants.SAP || systemType === SystemTypeConstants.ORACLE;
}

export function isSalesforceSystem(systemType: string): boolean {
    return systemType === SystemTypeConstants.SALESFORCE;
}
